
export default {

    setCount(state, count) {
      state.count = count
    },

    setDevis (state, devis) {
      state.all = devis
      state.initialized = true
      state.page = 1
    },

    setNextDevis (state, devis) {    
      state.all = [ ...state.all, ...devis ]
      state.page++
    }
}